import * as yup from 'yup';
import { isAfter, isMatch, isValid, parse, parseISO, set } from 'date-fns';

const parseToToday = (timeValue) => {
  if (!timeValue) return null;

  const toToday = (dateValue) => set(new Date(), {
    hours: dateValue.getHours(),
    minutes: dateValue.getMinutes(),
    seconds: dateValue.getSeconds(),
    milliseconds: 0,
  });

  if (timeValue instanceof Date && isValid(timeValue)) {
    return toToday(timeValue);
  }

  if (typeof timeValue === 'string') {
    const normalized = timeValue.trim();
    if (!normalized) return null;

    if (isMatch(normalized, 'HH:mm')) {
      return toToday(parse(normalized, 'HH:mm', new Date()));
    }

    if (isMatch(normalized, 'HH:mm:ss')) {
      return toToday(parse(normalized, 'HH:mm:ss', new Date()));
    }

    const isoDate = parseISO(normalized);
    if (isValid(isoDate)) {
      return toToday(isoDate);
    }
  }

  return null;
};

const timeProfileSchema = yup.object().shape({
  startTime: yup.date().typeError('startTimeRequired').required('startTimeRequired'),
  endTime: yup.date()
    .typeError('endTimeRequired')
    .required('endTimeRequired')
    .test('is-after-start', 'endTimeMustBeAfterStartTime', function validateEndTime(value) {
      const { startTime } = this.parent || {};
      if (!startTime || !value) return false;

      const start = parseToToday(startTime);
      const end = parseToToday(value);

      if (!start || !end) return false;
      return isAfter(end, start);
    }),
  days: yup.array().of(yup.number()).min(1, 'daysRequired').required('daysRequired'),
});

const timeProfileFormSchema = yup.object().shape({
  name: yup.string().required('timeProfileNameRequired'),
  timeProfiles: yup.array().of(timeProfileSchema).min(1, 'timeProfilesRequired').required('timeProfilesRequired'),
});

export default timeProfileFormSchema;

